const ACRES_PER_HECTARE = 2.47105;
const SQM_PER_ACRE = 4046.8564224;

/**
 * Converts area from square meters to acres
 */
export function squareMetersToAcres(sqm: number): number {
    return Math.round((sqm / SQM_PER_ACRE) * 100) / 100;
}

export function hectaresToAcres(hectares: number): number {
    return Math.round(hectares * ACRES_PER_HECTARE * 100) / 100;
}
